import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PureAbility } from '@casl/ability';

import { AppAbilities, AppSubjects } from './types';

/**
 * Generieke guard voor CASL permissiechecks in de router.
 * Gebruik in routes.ts:
 * {
 *   path: 'secret',
 *   component: SecretComponent,
 *   canActivate: [canAbilityGuard('read', 'Project')]
 * }
 */
export const canAbilityGuard = (action: AppAbilities, subject: AppSubjects): CanActivateFn => {
  return async () => {
    const ability = inject(PureAbility);
    await new Promise(resolve => setTimeout(resolve, 1)); // Hier wacht ik een tick zodat ability zijn permissies door signals zijn geupdate.
    if (ability.can(action, subject)) {
      return true;
    } else {
      console.warn(`Toegang geweigerd: geen permissie om ${action} op ${subject} uit te voeren.`);
      return false;
    }
  };
};
